export var SavedSearchState;
(function (SavedSearchState) {
    SavedSearchState["none"] = "none";
    SavedSearchState["enabled"] = "enabled";
    SavedSearchState["disabled"] = "disabled";
})(SavedSearchState || (SavedSearchState = {}));
export var EstateType;
(function (EstateType) {
    EstateType["None"] = "None";
    EstateType["HOUSE"] = "HOUSE";
    EstateType["APARTMENT"] = "APARTMENT";
    EstateType["PLOT"] = "PLOT";
    EstateType["BUILDING"] = "BUILDING";
    EstateType["OFFICE"] = "OFFICE";
    EstateType["TRADING"] = "TRADING";
    EstateType["GASTRONOMY_HOTEL"] = "GASTRONOMY_HOTEL";
    EstateType["STORAGE_PRODUCTION"] = "STORAGE_PRODUCTION";
    EstateType["AGRICULTURE_FORESTRY"] = "AGRICULTURE_FORESTRY";
    EstateType["PARKING"] = "PARKING";
    EstateType["SENIOR"] = "SENIOR";
    EstateType["PROJECT"] = "PROJECT";
    EstateType["MISCELLANEOUS"] = "MISCELLANEOUS";
})(EstateType || (EstateType = {}));
export var EstateSubType;
(function (EstateSubType) {
    EstateSubType["None"] = "None";
    EstateSubType["APARTMENT_HOUSE"] = "APARTMENT_HOUSE";
    EstateSubType["BUNGALOW"] = "BUNGALOW";
    EstateSubType["CASTLE"] = "CASTLE";
    EstateSubType["MANSION"] = "MANSION";
    EstateSubType["MANOR_HOUSE"] = "MANOR_HOUSE";
    EstateSubType["CHALET"] = "CHALET";
    EstateSubType["FARMHOUSE"] = "FARMHOUSE";
    EstateSubType["FINCA"] = "FINCA";
    EstateSubType["GARDEN_HOUSE"] = "GARDEN_HOUSE";
    EstateSubType["GITE"] = "GITE";
    EstateSubType["LIVING_AND_COMMERCIAL"] = "LIVING_AND_COMMERCIAL";
    EstateSubType["MULTI_FAMILY_HOUSE"] = "MULTI_FAMILY_HOUSE";
    EstateSubType["MOUNTAIN_HUT"] = "MOUNTAIN_HUT";
    EstateSubType["RESIDENTIAL_COMPLEX"] = "RESIDENTIAL_COMPLEX";
    EstateSubType["RUSTICO"] = "RUSTICO";
    EstateSubType["SEMIDETACHED_HOUSE"] = "SEMIDETACHED_HOUSE";
    EstateSubType["SINGLE_FAMILY_HOUSE"] = "SINGLE_FAMILY_HOUSE";
    EstateSubType["SPECIAL_REAL_ESTATE"] = "SPECIAL_REAL_ESTATE";
    EstateSubType["TERRACE_HOUSE"] = "TERRACE_HOUSE";
    EstateSubType["CORNER_TERRACE_HOUSE"] = "CORNER_TERRACE_HOUSE";
    EstateSubType["END_TERRACE_HOUSE"] = "END_TERRACE_HOUSE";
    EstateSubType["MID_TERRACE_HOUSE"] = "MID_TERRACE_HOUSE";
    EstateSubType["TOWN_HOUSE"] = "TOWN_HOUSE";
    EstateSubType["VILLA"] = "VILLA";
    EstateSubType["COUNTRY_COTTAGE"] = "COUNTRY_COTTAGE";
    EstateSubType["PAVILION"] = "PAVILION";
    EstateSubType["NEW_BUILD_PROGRAM_HOUSE"] = "NEW_BUILD_PROGRAM_HOUSE";
    EstateSubType["MULTI_STOREY"] = "MULTI_STOREY";
    EstateSubType["FLATSHARING_ROOM"] = "FLATSHARING_ROOM";
    EstateSubType["LOFT"] = "LOFT";
    EstateSubType["LOFT_ATELIER"] = "LOFT_ATELIER";
    EstateSubType["PENTHOUSE"] = "PENTHOUSE";
    EstateSubType["STUDIO"] = "STUDIO";
    EstateSubType["TERRACE"] = "TERRACE";
    EstateSubType["UNFINISHED_ATTIC_SPACE"] = "UNFINISHED_ATTIC_SPACE";
    EstateSubType["KOT"] = "KOT";
    EstateSubType["NEW_BUILD_PROGRAM_APARTMENT"] = "NEW_BUILD_PROGRAM_APARTMENT";
    EstateSubType["LIVING"] = "LIVING";
    EstateSubType["COMMERCIAL"] = "COMMERCIAL";
    EstateSubType["INDUSTRY"] = "INDUSTRY";
    EstateSubType["AGRICULTURE_FORESTRY"] = "AGRICULTURE_FORESTRY";
    EstateSubType["MIXED"] = "MIXED";
    EstateSubType["LEISURE_FACILITY"] = "LEISURE_FACILITY";
    EstateSubType["COMMERCIAL_PARC"] = "COMMERCIAL_PARC";
    EstateSubType["SPECIAL_USE"] = "SPECIAL_USE";
    EstateSubType["LAKESIDE_PROPERTY"] = "LAKESIDE_PROPERTY";
    EstateSubType["STRUCTURE"] = "STRUCTURE";
    EstateSubType["SINGLE_OFFICE"] = "SINGLE_OFFICE";
    EstateSubType["OFFICE_SPACE"] = "OFFICE_SPACE";
    EstateSubType["OFFICE_BUILDING"] = "OFFICE_BUILDING";
    EstateSubType["OFFICE_CENTRE"] = "OFFICE_CENTRE";
    EstateSubType["OFFICE_STORAGE_BUILDING"] = "OFFICE_STORAGE_BUILDING";
    EstateSubType["MEDICAL"] = "MEDICAL";
    EstateSubType["MEDICAL_FLOOR"] = "MEDICAL_FLOOR";
    EstateSubType["MEDICAL_BUILDING"] = "MEDICAL_BUILDING";
    EstateSubType["LIVING_AND_COMMERCIAL_BUILDING"] = "LIVING_AND_COMMERCIAL_BUILDING";
    EstateSubType["ATELIER"] = "ATELIER";
    EstateSubType["COWORKING"] = "COWORKING";
    EstateSubType["OPEN_SPACE"] = "OPEN_SPACE";
    EstateSubType["SHARED_OFFICE"] = "SHARED_OFFICE";
    EstateSubType["LARGE_TOWN_HOUSE"] = "LARGE_TOWN_HOUSE";
    EstateSubType["COMMERCIAL_VILLA"] = "COMMERCIAL_VILLA";
    EstateSubType["BOUTIQUE"] = "BOUTIQUE";
    EstateSubType["STORE"] = "STORE";
    EstateSubType["SHOWROOM_SPACE"] = "SHOWROOM_SPACE";
    EstateSubType["SHOPPING_CENTRE"] = "SHOPPING_CENTRE";
    EstateSubType["KIOSK"] = "KIOSK";
    EstateSubType["SALES_AREA"] = "SALES_AREA";
    EstateSubType["CAFE_BAR_PUB"] = "CAFE_BAR_PUB";
    EstateSubType["RESTAURANT"] = "RESTAURANT";
    EstateSubType["CLUB_DISCOTHEQUE"] = "CLUB_DISCOTHEQUE";
    EstateSubType["HOTEL"] = "HOTEL";
    EstateSubType["APART_HOTEL"] = "APART_HOTEL";
    EstateSubType["LEISURE"] = "LEISURE";
    EstateSubType["MIXED_USE_BUILDING_COMMERCIAL"] = "MIXED_USE_BUILDING_COMMERCIAL";
    EstateSubType["WAREHOUSE_HALL"] = "WAREHOUSE_HALL";
    EstateSubType["LOGISTICS_CENTER"] = "LOGISTICS_CENTER";
    EstateSubType["PRODUCTION_HALL"] = "PRODUCTION_HALL";
    EstateSubType["GARAGE_REPAIR"] = "GARAGE_REPAIR";
    EstateSubType["OUTDOOR_SPACE"] = "OUTDOOR_SPACE";
    EstateSubType["MISC_STORAGE"] = "MISC_STORAGE";
    EstateSubType["FARM_RANCH"] = "FARM_RANCH";
    EstateSubType["AGRICULTURE_COMPANY"] = "AGRICULTURE_COMPANY";
    EstateSubType["GARDENING"] = "GARDENING";
    EstateSubType["FORESTRY"] = "FORESTRY";
    EstateSubType["WINERY"] = "WINERY";
    EstateSubType["HUNTING"] = "HUNTING";
    EstateSubType["FISHING"] = "FISHING";
    EstateSubType["RIDING"] = "RIDING";
    EstateSubType["MISC_AGRICULTURE"] = "MISC_AGRICULTURE";
    EstateSubType["ORCHARD"] = "ORCHARD";
    EstateSubType["MEADOW"] = "MEADOW";
    EstateSubType["FIELDS"] = "FIELDS";
    EstateSubType["OUTSIDE"] = "OUTSIDE";
    EstateSubType["STREET_PARKING"] = "STREET_PARKING";
    EstateSubType["CARPORT"] = "CARPORT";
    EstateSubType["GARAGE"] = "GARAGE";
    EstateSubType["DOUBLE_GARAGE"] = "DOUBLE_GARAGE";
    EstateSubType["DUPLEX"] = "DUPLEX";
    EstateSubType["GARAGE_AREA"] = "GARAGE_AREA";
    EstateSubType["PARKING_AREA"] = "PARKING_AREA";
    EstateSubType["CAR_PARK"] = "CAR_PARK";
    EstateSubType["UNDERGROUND_GARAGE"] = "UNDERGROUND_GARAGE";
    EstateSubType["UNDERGROUND_PARKING_SPACE"] = "UNDERGROUND_PARKING_SPACE";
    EstateSubType["BOAT_DOCK"] = "BOAT_DOCK";
    EstateSubType["ASSISTED_LIVING"] = "ASSISTED_LIVING";
    EstateSubType["MEDICAL_CARE"] = "MEDICAL_CARE";
    EstateSubType["HOUSE_PARK"] = "HOUSE_PARK";
    EstateSubType["HOUSE_TO_BUILD"] = "HOUSE_TO_BUILD";
    EstateSubType["HOUSE_TO_BUILD_WITH_PLOT"] = "HOUSE_TO_BUILD_WITH_PLOT";
    EstateSubType["MISCELLANEOUS"] = "MISCELLANEOUS";
    EstateSubType["CAMPSITE"] = "CAMPSITE";
    EstateSubType["BARGE"] = "BARGE";
    EstateSubType["MILL"] = "MILL";
    EstateSubType["HOLIDAY_PARK"] = "HOLIDAY_PARK";
    EstateSubType["MOBILE_HOME"] = "MOBILE_HOME";
    EstateSubType["STATIC_CARAVAN"] = "STATIC_CARAVAN";
    EstateSubType["BED_N_BREAKFAST"] = "BED_N_BREAKFAST";
})(EstateSubType || (EstateSubType = {}));
export var DistributionType;
(function (DistributionType) {
    DistributionType["BUY"] = "BUY";
    DistributionType["RENT"] = "RENT";
    DistributionType["COMPULSORY_AUCTION"] = "COMPULSORY_AUCTION";
    DistributionType["BUY_AUCTION"] = "BUY_AUCTION";
})(DistributionType || (DistributionType = {}));
export var DistributionSubType;
(function (DistributionSubType) {
    DistributionSubType["BUSINESS_LEASEBACK"] = "BUSINESS_LEASEBACK";
    DistributionSubType["BUSINESS_SALE_GOODWILL"] = "BUSINESS_SALE_GOODWILL";
    DistributionSubType["RESALE"] = "RESALE";
    DistributionSubType["LIFE_ANNUITY"] = "LIFE_ANNUITY";
    DistributionSubType["NEW_BUILD_UNIT"] = "NEW_BUILD_UNIT";
    DistributionSubType["NEW_BUILD_INVESTMENT_PRODUCT"] = "NEW_BUILD_INVESTMENT_PRODUCT";
    DistributionSubType["NEW_BUILD_PROJECT"] = "NEW_BUILD_PROJECT";
    DistributionSubType["NEW_HOME"] = "NEW_HOME";
    DistributionSubType["BUSINESS"] = "BUSINESS";
    DistributionSubType["CLASSIC"] = "CLASSIC";
    DistributionSubType["TEMPORARY"] = "TEMPORARY";
    DistributionSubType["VACATION"] = "VACATION";
})(DistributionSubType || (DistributionSubType = {}));
export var SpaceMeasureUnit;
(function (SpaceMeasureUnit) {
    SpaceMeasureUnit["SQUARE_METER"] = "SQUARE_METER";
    SpaceMeasureUnit["SQUARE_INCH"] = "SQUARE_INCH";
    SpaceMeasureUnit["SQUARE_FOOT"] = "SQUARE_FOOT";
    SpaceMeasureUnit["SQUARE_YARD"] = "SQUARE_YARD";
    SpaceMeasureUnit["HECTARE"] = "HECTARE";
    SpaceMeasureUnit["ACRE"] = "ACRE";
})(SpaceMeasureUnit || (SpaceMeasureUnit = {}));
export var LocationInBuilding;
(function (LocationInBuilding) {
    LocationInBuilding["UNKNOWN"] = "UNKNOWN";
    LocationInBuilding["GROUNDFLOOR"] = "GROUNDFLOOR";
    LocationInBuilding["HALF_BASEMENT"] = "HALF_BASEMENT";
    LocationInBuilding["ROOF_STOREY"] = "ROOF_STOREY";
    LocationInBuilding["GROUNDFLOOR_EXCLUDED"] = "GROUNDFLOOR_EXCLUDED";
    LocationInBuilding["HALF_BASEMENT_EXCLUDED"] = "HALF_BASEMENT_EXCLUDED";
    LocationInBuilding["ROOF_STOREY_EXCLUDED"] = "ROOF_STOREY_EXCLUDED";
})(LocationInBuilding || (LocationInBuilding = {}));
export var KitchenEquipment;
(function (KitchenEquipment) {
    KitchenEquipment["UNKNOWN"] = "UNKNOWN";
    KitchenEquipment["NONE"] = "NONE";
    KitchenEquipment["STORAGE"] = "STORAGE";
    KitchenEquipment["FULLY_EQUIPPED"] = "FULLY_EQUIPPED";
})(KitchenEquipment || (KitchenEquipment = {}));
export var Garden;
(function (Garden) {
    Garden["None"] = "None";
    Garden["ANYKIND"] = "ANYKIND";
    Garden["PART"] = "PART";
    Garden["PRIVATE"] = "PRIVATE";
    Garden["SHARED"] = "SHARED";
})(Garden || (Garden = {}));
export var Elevator;
(function (Elevator) {
    Elevator["None"] = "None";
    Elevator["ANYKIND"] = "ANYKIND";
    Elevator["PERSON"] = "PERSON";
    Elevator["FREIGTH"] = "FREIGTH";
})(Elevator || (Elevator = {}));
export var Furnished;
(function (Furnished) {
    Furnished["None"] = "None";
    Furnished["ANYKIND"] = "ANYKIND";
    Furnished["PART"] = "PART";
    Furnished["FULL"] = "FULL";
    Furnished["NO"] = "NO";
    Furnished["NOT_APPLICABLE"] = "NOT_APPLICABLE";
})(Furnished || (Furnished = {}));
export var PropertyOrientation;
(function (PropertyOrientation) {
    PropertyOrientation["None"] = "None";
    PropertyOrientation["NORTH"] = "NORTH";
    PropertyOrientation["EAST"] = "EAST";
    PropertyOrientation["SOUTH"] = "SOUTH";
    PropertyOrientation["WEST"] = "WEST";
    PropertyOrientation["NORTH_EAST"] = "NORTH_EAST";
    PropertyOrientation["SOUTH_EAST"] = "SOUTH_EAST";
    PropertyOrientation["NORTH_WEST"] = "NORTH_WEST";
    PropertyOrientation["SOUTH_WEST"] = "SOUTH_WEST";
})(PropertyOrientation || (PropertyOrientation = {}));
export var BuildState;
(function (BuildState) {
    BuildState["None"] = "None";
    BuildState["ANYKIND"] = "ANYKIND";
    BuildState["FIRST_TIME_USE"] = "FIRST_TIME_USE";
    BuildState["FIRST_TIME_USE_AFTER_REFURBISHMENT"] = "FIRST_TIME_USE_AFTER_REFURBISHMENT";
    BuildState["MINT_CONDITION"] = "MINT_CONDITION";
    BuildState["MODERNISED"] = "MODERNISED";
    BuildState["REFURBISHED"] = "REFURBISHED";
    BuildState["FULLY_RENOVATED"] = "FULLY_RENOVATED";
    BuildState["PARTLY_RENOVATED"] = "PARTLY_RENOVATED";
    BuildState["NEED_OF_RENOVATION"] = "NEED_OF_RENOVATION";
    BuildState["WELL_KEPT"] = "WELL_KEPT";
    BuildState["NEGOTIABLE"] = "NEGOTIABLE";
    BuildState["RIPE_FOR_DEMOLITION"] = "RIPE_FOR_DEMOLITION";
    BuildState["PROJECTED"] = "PROJECTED";
    BuildState["NO_INFORMATION"] = "NO_INFORMATION";
    BuildState["RESTRUCTURED"] = "RESTRUCTURED";
    BuildState["TO_RESTORE"] = "TO_RESTORE";
    BuildState["TO_REFURBISH"] = "TO_REFURBISH";
})(BuildState || (BuildState = {}));
export var Cellar;
(function (Cellar) {
    Cellar["None"] = "None";
    Cellar["ANYKIND"] = "ANYKIND";
    Cellar["PART"] = "PART";
    Cellar["YES"] = "YES";
    Cellar["NO"] = "NO";
    Cellar["NOT_APPLICABLE"] = "NOT_APPLICABLE";
})(Cellar || (Cellar = {}));
export var HasFee;
(function (HasFee) {
    HasFee["None"] = "None";
    HasFee["YES"] = "YES";
    HasFee["NO"] = "NO";
    HasFee["NOT_APPLICABLE"] = "NOT_APPLICABLE";
})(HasFee || (HasFee = {}));
export var BuildingAttic;
(function (BuildingAttic) {
    BuildingAttic["None"] = "None";
    BuildingAttic["CONVERTED"] = "CONVERTED";
    BuildingAttic["PART_CONVERTED"] = "PART_CONVERTED";
    BuildingAttic["CONVERTIBLE"] = "CONVERTIBLE";
})(BuildingAttic || (BuildingAttic = {}));
export var ManagementUseFor;
(function (ManagementUseFor) {
    ManagementUseFor["None"] = "None";
    ManagementUseFor["LIVING"] = "LIVING";
    ManagementUseFor["COMMERCIAL"] = "COMMERCIAL";
    ManagementUseFor["MIXED"] = "MIXED";
    ManagementUseFor["OFFICE"] = "OFFICE";
    ManagementUseFor["INDUSTRIAL"] = "INDUSTRIAL";
})(ManagementUseFor || (ManagementUseFor = {}));
export var EnergyClass;
(function (EnergyClass) {
    EnergyClass["None"] = "None";
    EnergyClass["A_PLUS_PLUS"] = "A_PLUS_PLUS";
    EnergyClass["A_PLUS"] = "A_PLUS";
    EnergyClass["A"] = "A";
    EnergyClass["B"] = "B";
    EnergyClass["C"] = "C";
    EnergyClass["D"] = "D";
    EnergyClass["E"] = "E";
    EnergyClass["F"] = "F";
    EnergyClass["G"] = "G";
    EnergyClass["H"] = "H";
})(EnergyClass || (EnergyClass = {}));
export var EnergyHeatMethod;
(function (EnergyHeatMethod) {
    EnergyHeatMethod["None"] = "None";
    EnergyHeatMethod["ANYKIND"] = "ANYKIND";
    EnergyHeatMethod["CENTRAL"] = "CENTRAL";
    EnergyHeatMethod["INDIVIDUAL"] = "INDIVIDUAL";
    EnergyHeatMethod["STOREY"] = "STOREY";
})(EnergyHeatMethod || (EnergyHeatMethod = {}));
export var EnergyHeatForm;
(function (EnergyHeatForm) {
    EnergyHeatForm["None"] = "None";
    EnergyHeatForm["ANYKIND"] = "ANYKIND";
    EnergyHeatForm["AIR"] = "AIR";
    EnergyHeatForm["RADIATOR"] = "RADIATOR";
    EnergyHeatForm["STOVE"] = "STOVE";
    EnergyHeatForm["UNDERFLOOR"] = "UNDERFLOOR";
    EnergyHeatForm["WALLCEILING"] = "WALLCEILING";
    EnergyHeatForm["MIXED"] = "MIXED";
})(EnergyHeatForm || (EnergyHeatForm = {}));
export var EnergySource;
(function (EnergySource) {
    EnergySource["None"] = "None";
    EnergySource["ANYKIND"] = "ANYKIND";
    EnergySource["COAL"] = "COAL";
    EnergySource["DISTRICTHEATING"] = "DISTRICTHEATING";
    EnergySource["ELECTRIC"] = "ELECTRIC";
    EnergySource["GAS"] = "GAS";
    EnergySource["GEOTHERMAL"] = "GEOTHERMAL";
    EnergySource["LIQUIDGAS"] = "LIQUIDGAS";
    EnergySource["OIL"] = "OIL";
    EnergySource["SOLARHEAT"] = "SOLARHEAT";
    EnergySource["SOLARPOWER"] = "SOLARPOWER";
    EnergySource["WIND"] = "WIND";
    EnergySource["WOOD"] = "WOOD";
    EnergySource["WOODPELLET"] = "WOODPELLET";
    EnergySource["HASTHERMICPANELS"] = "HASTHERMICPANELS";
    EnergySource["HASPHOTOVOLTAICPANELS"] = "HASPHOTOVOLTAICPANELS";
})(EnergySource || (EnergySource = {}));
export var SwimmingPool;
(function (SwimmingPool) {
    SwimmingPool["None"] = "None";
    SwimmingPool["ANYKIND"] = "ANYKIND";
    SwimmingPool["YES"] = "YES";
    SwimmingPool["NO"] = "NO";
    SwimmingPool["INSIDE"] = "INSIDE";
    SwimmingPool["OUTSIDE"] = "OUTSIDE";
    SwimmingPool["INSIDE_AND_OUTSIDE"] = "INSIDE_AND_OUTSIDE";
    SwimmingPool["NOT_APPLICABLE"] = "NOT_APPLICABLE";
})(SwimmingPool || (SwimmingPool = {}));
export var NotificationsTargetEnum;
(function (NotificationsTargetEnum) {
    NotificationsTargetEnum["EMAIL"] = "email";
    NotificationsTargetEnum["RECOMMENDATIONS"] = "recommendations";
})(NotificationsTargetEnum || (NotificationsTargetEnum = {}));
export var SavedSearchOrigin;
(function (SavedSearchOrigin) {
    SavedSearchOrigin["SavedSearch"] = "SavedSearch";
    SavedSearchOrigin["CurrentSearch"] = "CurrentSearch";
})(SavedSearchOrigin || (SavedSearchOrigin = {}));
export var SavedSearchDeviceType;
(function (SavedSearchDeviceType) {
    SavedSearchDeviceType["None"] = "None";
    SavedSearchDeviceType["Android"] = "Android";
    SavedSearchDeviceType["IOS"] = "IOS";
})(SavedSearchDeviceType || (SavedSearchDeviceType = {}));
export var SavedSearchNotificationChannel;
(function (SavedSearchNotificationChannel) {
    SavedSearchNotificationChannel["email"] = "email";
    SavedSearchNotificationChannel["mobile"] = "mobile";
})(SavedSearchNotificationChannel || (SavedSearchNotificationChannel = {}));
export var SavedSearchFrequency;
(function (SavedSearchFrequency) {
    SavedSearchFrequency["realtime"] = "realtime";
    SavedSearchFrequency["daily"] = "daily";
    SavedSearchFrequency["hourly"] = "hourly";
})(SavedSearchFrequency || (SavedSearchFrequency = {}));
export var MatchCriteriaRelaxed;
(function (MatchCriteriaRelaxed) {
    MatchCriteriaRelaxed["None"] = "None";
    MatchCriteriaRelaxed["Location"] = "Location";
    MatchCriteriaRelaxed["PriceMax"] = "PriceMax";
    MatchCriteriaRelaxed["FloorSpaceMin"] = "FloorSpaceMin";
    MatchCriteriaRelaxed["PlotSpaceMin"] = "PlotSpaceMin";
    MatchCriteriaRelaxed["FloorNumber"] = "FloorNumber";
    MatchCriteriaRelaxed["Garden"] = "Garden";
    MatchCriteriaRelaxed["Elevator"] = "Elevator";
    MatchCriteriaRelaxed["Cellar"] = "Cellar";
    MatchCriteriaRelaxed["Furnished"] = "Furnished";
    MatchCriteriaRelaxed["IsRented"] = "IsRented";
    MatchCriteriaRelaxed["BathroomWindow"] = "BathroomWindow";
    MatchCriteriaRelaxed["BathroomBathtub"] = "BathroomBathtub";
    MatchCriteriaRelaxed["HasBrokerageFee"] = "HasBrokerageFee";
    MatchCriteriaRelaxed["KitchenEquipment"] = "KitchenEquipment";
    MatchCriteriaRelaxed["MinParkings"] = "MinParkings";
    MatchCriteriaRelaxed["MinGarages"] = "MinGarages";
    MatchCriteriaRelaxed["MinTerraces"] = "MinTerraces";
    MatchCriteriaRelaxed["MinBalconies"] = "MinBalconies";
    MatchCriteriaRelaxed["SwimmingPool"] = "SwimmingPool";
    MatchCriteriaRelaxed["EnergyHeatForm"] = "EnergyHeatForm";
    MatchCriteriaRelaxed["EnergySource"] = "EnergySource";
    MatchCriteriaRelaxed["EnergyHeatMethod"] = "EnergyHeatMethod";
    MatchCriteriaRelaxed["EnergyClass"] = "EnergyClass";
    MatchCriteriaRelaxed["PropertyOrientation"] = "PropertyOrientation";
    MatchCriteriaRelaxed["ViewWithoutOverlooking"] = "ViewWithoutOverlooking";
    MatchCriteriaRelaxed["ViewNiceView"] = "ViewNiceView";
    MatchCriteriaRelaxed["LegalNotes"] = "LegalNotes";
})(MatchCriteriaRelaxed || (MatchCriteriaRelaxed = {}));
export var LocationGeometryCircleRadiusUnit;
(function (LocationGeometryCircleRadiusUnit) {
    LocationGeometryCircleRadiusUnit["km"] = "km";
    LocationGeometryCircleRadiusUnit["m"] = "m";
})(LocationGeometryCircleRadiusUnit || (LocationGeometryCircleRadiusUnit = {}));
export var LocationGeometryTravelMode;
(function (LocationGeometryTravelMode) {
    LocationGeometryTravelMode["WALK"] = "WALK";
    LocationGeometryTravelMode["BIKE"] = "BIKE";
    LocationGeometryTravelMode["TRANSIT"] = "TRANSIT";
    LocationGeometryTravelMode["CAR"] = "CAR";
})(LocationGeometryTravelMode || (LocationGeometryTravelMode = {}));
export var LocationGeometryTravelUnit;
(function (LocationGeometryTravelUnit) {
    LocationGeometryTravelUnit["MINUTE"] = "MINUTE";
    LocationGeometryTravelUnit["KM"] = "KM";
})(LocationGeometryTravelUnit || (LocationGeometryTravelUnit = {}));
export var LegalNote;
(function (LegalNote) {
    LegalNote["None"] = "None";
    LegalNote["LOIDUFLOTOUTRE"] = "LOIDUFLOTOUTRE";
    LegalNote["LOILMP"] = "LOILMP";
    LegalNote["LOILMNP"] = "LOILMNP";
    LegalNote["PLSINVESTISSEUR"] = "PLSINVESTISSEUR";
    LegalNote["LOITVA55"] = "LOITVA55";
    LegalNote["DEMEMBREMENT"] = "DEMEMBREMENT";
    LegalNote["LOITVA7"] = "LOITVA7";
    LegalNote["LOIEHPAD"] = "LOIEHPAD";
    LegalNote["AUCUNELOI"] = "AUCUNELOI";
    LegalNote["LOIPINEL"] = "LOIPINEL";
    LegalNote["ANRU"] = "ANRU";
    LegalNote["BRS"] = "BRS";
    LegalNote["LOIPINELPLUS"] = "LOIPINELPLUS";
})(LegalNote || (LegalNote = {}));
export var MigrationState;
(function (MigrationState) {
    MigrationState["None"] = "None";
    MigrationState["Requested"] = "Requested";
    MigrationState["InProgress"] = "InProgress";
    MigrationState["Completed"] = "Completed";
    MigrationState["Failed"] = "Failed";
    MigrationState["NoSearchToMigrate"] = "NoSearchToMigrate";
})(MigrationState || (MigrationState = {}));
